import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { AltTransMeasureProgress } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";

export function useAlternativeTransportMeasureProgress(
  incidentId: string | null | undefined,
) {
  const { data, status, refetch, isRefetching } = useQuery({
    queryKey: ["alternativeTransport", "measureProgress", incidentId],
    enabled: Boolean(incidentId),
    queryFn: async ({ signal }) => {
      const response = await axiosClient.get<AltTransMeasureProgress>(
        `${getBackendUrl()}/alternative-transport-planning/incident/${incidentId}/measure-progress`,
        {
          signal,
        },
      );
      return response.data;
    },
    refetchInterval: 60 * 1000, // Every minute
    retry: false,
  });

  return { data, status, refetch, isRefetching };
}
